import React, {useState} from 'react';
import {createPortal} from 'react-dom';
import './CustomerReceipt.css';

const preference = 'murai-receipt-paper-mm';
const money = value => Number(value || 0).toLocaleString('en-IN', {minimumFractionDigits:2, maximumFractionDigits:2});
export function CustomerReceipt({bill}) {
 const open=bill.status==='Open';
 const collected=bill.payment_collections?.flatMap(event=>event.payments || []) || [];
 const payments=collected.length?collected:bill.payments || [];
 const methods=[...new Set(payments.map(payment=>({cash:'Cash',upi:'UPI',card:'Card'})[payment.method]).filter(Boolean))];
 return <article className="customer-receipt" aria-label="Customer receipt">
  <h2>{bill.brand_name}</h2><p>{open?'Open order — sale not completed':'Receipt'} {bill.bill_number}</p>
  <p>{open?bill.created_business_date:bill.business_date} · {bill.channel_name}</p>
  <p>{(open?bill.created_at:bill.completed_at)&&new Date(open?bill.created_at:bill.completed_at).toLocaleString('en-IN',{timeZone:'Asia/Kolkata'})}</p>
  {bill.status==='Voided'&&<strong>VOIDED</strong>}
  <table><thead><tr><th>Qty</th><th>Price</th><th>Amount</th></tr></thead>{(bill.lines || []).map((line,index)=><tbody key={index}><tr><td className="receipt-item-name" colSpan={3}>{line.item_name}{line.output_variant_name?` · ${line.output_variant_name}`:''}</td></tr><tr><td>{line.quantity}</td><td>{money(line.unit_price)}</td><td>{money(line.line_amount)}</td></tr></tbody>)}</table>
  <p>Subtotal ₹{money(bill.subtotal)}</p><p>Discount ₹{money(bill.discount_amount)}</p>
  <strong>Total ₹{money(bill.final_customer_amount)}</strong>
  <p>Payment: {bill.aggregator_payment?`${bill.aggregator_payment.channel_name} / Prepaid`:methods.join(' + ') || 'Not recorded'}</p>
  {!bill.aggregator_payment&&Number(bill.outstanding_due)>0&&<p>Outstanding due ₹{money(bill.outstanding_due)}</p>}
  {bill.expected_fulfilment_date&&<p>Pickup: {bill.expected_fulfilment_date}</p>}
  {bill.order_note&&<p>{bill.order_note}</p>}
 </article>;
}
export default function ReceiptPrint({bill, label='Print Bill / receipt'}) {
 const [choosing,setChoosing]=useState(false),[error,setError]=useState('');
 const print=width=>{
  if(!['80','58'].includes(width)){setChoosing(true);return;}
  setChoosing(false);setError('');
  document.documentElement.style.setProperty('--receipt-width',`${width}mm`);
  document.body.classList.add('printing-customer-receipt');
  try{window.print();}catch{setError('Printing could not open. The saved Bill is unchanged.');}
  finally{document.body.classList.remove('printing-customer-receipt');}
 };
 const start=()=>{let width;try{width=localStorage.getItem(preference);}catch{}print(width);};
 const choose=width=>{try{localStorage.setItem(preference,width);}catch{}print(width);};
 return <><button type="button" onClick={start}>{label}</button><button type="button" className="text-btn" onClick={()=>setChoosing(true)}>Paper size</button>
  {choosing&&<section aria-label="Receipt paper size"><strong>Receipt paper size</strong><p>Choose the paper loaded in your printer. Match this in the browser print settings.</p>{['80','58'].map(width=><button type="button" key={width} onClick={()=>choose(width)}>{width} mm</button>)}<button type="button" onClick={()=>setChoosing(false)}>Cancel</button></section>}
  {error&&<p role="alert">{error}</p>}
  {createPortal(<div className="customer-receipt-print-root"><CustomerReceipt bill={bill}/></div>,document.body)}
 </>;
}
